import { LogService } from 'src/app/infrastructure/services/log.service';
import { TClaimListView } from 'src/app/features/claim/models/claim-list-view';
import { TFunctionMemberListView } from 'src/app/features/function-member/models/function-member-list-view';
import { TProjectMemberListView } from 'src/app/features/project-member/models/project-member-list-view';

// Weergave-versie van de lijst in een tab (TabDataTemplate.listView): elke lijst met meerdere
// versies voegt zijn eigen union hier toe en zoekt alleen zijn eigen versies op in zijn spec-tabel.
// Elke waarde heeft de vorm '<lijst>.<versie>' (bv. 'functionMember.domain'), zodat versies van
// verschillende lijsten nooit dezelfde string hebben: een versie van een andere lijst matcht dan
// niet stil met een gelijknamige eigen versie, maar valt terug op de standaardversie + waarschuwing.
export type TListView = TClaimListView | TFunctionMemberListView | TProjectMemberListView;

// Spec van de versie uit de tab opzoeken in de spec-tabel van een lijst. Ontbrekende of onbekende
// versie (tab zonder listView, of een versie van een andere lijst): standaardversie + waarschuwing.
export function listViewSpec_get<TView extends TListView, TSpec>(
    specs: Record<TView, TSpec>,
    view: TListView | null,
    defaultView: TView,
    listName: string,
): TSpec {
    if (view != null && Object.hasOwn(specs, view)) return specs[view as TView];
    LogService.envDev.warn(listName, view == null
        ? 'geen listView in TabDataTemplate'
        : 'listView hoort niet bij deze lijst', String(view));
    return specs[defaultView];
}
